var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-grid"},[_c('div',{staticClass:"p-col-12"},[_c('div',{staticClass:"card"},[_c('h1',[_vm._v("Empty Page")]),_c('p',[_vm._v("Use this page to start from scratch and place your custom content.")])])])])
}]

export { render, staticRenderFns }